// @flow
import * as React from "react"
import withUser from "hoc/withUser"
import { compose, withStateHandlers, type HOC } from "recompose"
import SearchAutocomplete from "../SearchAutocomplete"
import Hamburger from "../../Hamburger"

const MobileLoggedInNav = ({
  user,
  hamburgerOpen,
  openHamburger,
  toggleHamburger,
  closeBoth,
  searchOpen,
  openSearch,
}) => (
  <React.Fragment>
    <Hamburger
      user={user}
      isOpen={hamburgerOpen}
      open={openHamburger}
      close={closeBoth}
      toggleOpen={toggleHamburger}
    />
    <SearchAutocomplete
      initialValue=""
      isOpen={searchOpen}
      open={openSearch}
      close={closeBoth}
    />
  </React.Fragment>
)

const enhancer: HOC<*, {||}> = compose(
  withUser(),
  withStateHandlers(
    {
      hamburgerOpen: false,
      searchOpen: false,
    },
    {
      closeBoth: () => () => ({ hamburgerOpen: false, searchOpen: false }),
      openHamburger: () => () => ({ hamburgerOpen: true, searchOpen: false }),
      openSearch: () => () => ({ hamburgerOpen: false, searchOpen: true }),
      toggleHamburger: ({ hamburgerOpen }) => () => ({
        searchOpen: false,
        hamburgerOpen: !hamburgerOpen,
      }),
    },
  ),
)

export default enhancer(MobileLoggedInNav)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/MobileLoggedInNav/index.js